import { types } from "mobx-state-tree";
export var BaseError = types.model("BaseError", {
    code: types.optional(types.number, -1),
    message: types.optional(types.string, ""),
});
